import ControlArea from "components/Layout/ControlArea";
import { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getPersonnels } from "store/actions";
import Icon from "../../assets/svgs/client.svg";
import Table from "./Table";

const Personnel = () => {
  const { personnels, loading, error } = useSelector(
    (state) => state.personnels
  );
  const dispatch = useDispatch();
  const { formatMessage, locale } = useIntl();

  useEffect(() => {
    dispatch(getPersonnels());
    // dispatch(getAllPageSections("categories"));
  }, [dispatch]);

  // error
  useEffect(() => {
    if (error) {
      toast.error(formatMessage({ id: "sendingErrorMessage" }), {
        position: locale === "ar" ? "bottom-left" : "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [error, formatMessage, locale]);

  return (
    <>
      <div className="categories-wrap">
        <ControlArea
          btnTxt={<FormattedMessage id={"addPersonCv"} />}
          cardTxt={<FormattedMessage id={"personnels"} />}
          icon={Icon}
          url="/personnels/add"
        />
        <Table data={personnels} loading={loading} />
      </div>
    </>
  );
};

export default Personnel;
